// CartPage.jsx
import React from "react";
import { getCartItems } from "./CartService";

const CartPage = () => {
  const items = getCartItems();

  return (
    <div>
      <h2>Cart Items</h2>
      {items.length === 0 ? (
        <p>No items in cart.</p>
      ) : (
        <ul>
          {items.map((item, index) => ( 
            <li key={item.id}> 
              {item.name} — Quantity: {item.quantity} 
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CartPage;
